import React from "react"
import Network from "../base-pages/network"

const NetworkCN = () => {
  return <Network lang="cn" />
}

export default NetworkCN
